module.exports = __webpack_public_path__ + "static/img/about_bg.67633f09.jpg";